module.exports = __webpack_public_path__ + "static/media/title_bg_3.facbbe9f.svg";